webpackJsonp([263791100135453],{

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMailto = __webpack_require__(78);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	function Index(_ref) {
		var data = _ref.data;
		var _data$site$siteMetada = data.site.siteMetadata,
		    email = _data$site$siteMetada.email,
		    about = _data$site$siteMetada.about;
	
	
		return _react2.default.createElement(
			"main",
			{ className: "container container-page" },
			_react2.default.createElement(
				"h1",
				null,
				"About Me"
			),
			about.map(function (paragraph, i) {
				return _react2.default.createElement(
					"p",
					{ key: i },
					paragraph
				);
			}),
			_react2.default.createElement(
				"p",
				null,
				"Drop me a line at",
				" ",
				_react2.default.createElement(
					_reactMailto2.default,
					{ email: email, obfuscate: false },
					email
				),
				"."
			)
		);
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-d1003a215802308a3ac8.js